import { Plus } from "lucide-react";
import { fmtMVR } from "@/lib/api";

export const MenuItemCard = ({ item, onAdd }) => {
    return (
        <div
            data-testid={`menu-item-${item.id}`}
            className="group relative bg-white rounded-2xl overflow-hidden border border-pz-border shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col"
        >
            <div className="relative aspect-[4/3] overflow-hidden bg-pz-cream">
                <div className="absolute inset-0 bg-pz-primary/90 mix-blend-multiply opacity-0 group-hover:opacity-30 transition-opacity z-10" />
                <img
                    src={item.image}
                    alt={item.name}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute top-3 left-3 z-20 bg-pz-text text-white text-xs uppercase tracking-widest px-3 py-1 rounded-full font-semibold">
                    {item.category}
                </div>
            </div>

            <div className="p-5 flex flex-col flex-1">
                <div className="flex items-start justify-between gap-3 mb-2">
                    <h3 className="font-display text-2xl leading-tight text-pz-text">
                        {item.name}
                    </h3>
                    <div className="font-display text-xl text-pz-primary whitespace-nowrap">
                        {fmtMVR(item.price)}
                    </div>
                </div>
                <p className="text-sm text-pz-textMuted leading-relaxed flex-1 mb-4">
                    {item.description}
                </p>
                <button
                    onClick={() => onAdd(item)}
                    data-testid={`add-to-cart-${item.id}`}
                    className="w-full inline-flex items-center justify-center gap-2 bg-pz-text text-white rounded-full py-3 px-5 font-semibold uppercase tracking-wider text-xs transition-all hover:bg-pz-primary hover:-translate-y-0.5"
                >
                    <Plus size={16} />
                    Add to Cart
                </button>
            </div>
        </div>
    );
};

export default MenuItemCard;
